import { NgModule, Optional, SkipSelf, ModuleWithProviders } from '@angular/core';

import { CommonModule } from '@angular/common';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { RouterModule } from '@angular/router';

import { EnvironmentConfig } from './services/config';
import { CacheService } from './services/cache';
import { SocketService } from './services/socket';
import { AuthService } from './services/http/auth';
import { EventService } from './services/events';
import { AppDB } from './services/database';
import { UserService } from './services/http/user';
import { PWAService } from './services/pwa';
import { TrackingService } from './services/tracking';
import { DiscountService } from './services/http/discount';
import { UrlInterceptor } from './interceptors/url-interceptor';
import { AuthInterceptor } from './interceptors/auth-interceptor';
import { CacheInterceptor } from './interceptors/cache-interceptor';
import { AuthGuard } from './guards/auth-guard';
import { NoAuthGuard } from './guards/no-auth-guard';
import { FeatureGuard } from './guards/feature.guard';

import { PageService } from './services/page';
import { CurrencyChangerService } from './services/currency-changer';
import { RouterActionService } from './services/router-action';
import { RecaptchaService } from './services/recaptcha';
import { PropertyService } from './services/http/property';
import { SetupService } from './services/http/setup';
import { GeneralService } from './services/general';
import { LeadService } from './services/http/lead';
import { TransactionService } from './services/http/transaction';
import { PaymentService } from './services/http/payment';
import { AdminService } from './services/http/admin';
import { TenantService } from './services/http/tenant';
import { AWSUploadService } from './services/http/aws-upload';
import { MessageService } from './services/http/message';
import { VideoService } from './services/http/video';
import { RoomService } from './services/http/room';
import { ImageService } from './services/http/image';
import { BlogService } from './services/http/blog';
import { ListingService } from './services/http/listing';
import { DataStoreService } from './services/datastore';
import { FeatureToggle } from './services/feature-toggle';
import { BookingService } from './services/http/booking';
import { EnquiresService } from './services/http/enquiry';
import { CMSService } from './services/http/cms';

@NgModule({
  imports: [
    CommonModule,
    HttpClientModule,
    RouterModule
  ],
  exports: [
    CommonModule,
    HttpClientModule,
    RouterModule
  ]
})
export class ClooperCoreModule {
  constructor(@Optional() @SkipSelf() core: ClooperCoreModule) {
    if (core) {
      throw new Error('You should import core module only in the root module');
    }
  }

  static forRoot(): ModuleWithProviders<ClooperCoreModule> {
    return {
      ngModule: ClooperCoreModule,
      providers: [
        AppDB,
        DataStoreService,
        EnvironmentConfig,
        FeatureToggle,
        CacheService,
        SocketService,
        AuthService,
        EventService,
        UserService,
        PWAService,
        TrackingService,
        PropertyService,
        PageService,
        CurrencyChangerService,
        RouterActionService,
        NoAuthGuard,
        AuthGuard,
        FeatureGuard,
        RecaptchaService,
        SetupService,
        GeneralService,
        LeadService,
        TransactionService,
        PaymentService,
        AdminService,
        TenantService,
        AWSUploadService,
        DiscountService,
        MessageService,
        VideoService,
        RoomService,
        ImageService,
        BlogService,
        ListingService,
        BookingService,
        EnquiresService,
        CMSService,

        [
          { provide: HTTP_INTERCEPTORS, useClass: UrlInterceptor, multi: true },
          { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
          { provide: HTTP_INTERCEPTORS, useClass: CacheInterceptor, multi: true }
        ]
      ]
    };
  }
}
